import {
  fetchBlog,
  fetchBlogFailure,
  fetchBlogs,
  fetchBlogsFailure,
  fetchBlogsSuccess,
  fetchBlogSuccess,
} from "../../store/slices/buyer/blogsSlice";
import { AppDispatch } from "../../store/store";
import { contentfulClient } from "../../views/common/utils/contentfulClient";

export const fetchBlogsAsync = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(fetchBlogs());

    if (!contentfulClient) {
      throw new Error("Contentful client not initialized");
    }

    const data: any = await contentfulClient.getEntries({
      content_type: "homeAndAbroad",
    });

    dispatch(fetchBlogsSuccess(data.items));
  } catch (err: any) {
    dispatch(fetchBlogsFailure(err.message || "Unable to fetch blogs"));
  }
};

export const fetchBlogAsync =
  (slug: string) => async (dispatch: AppDispatch) => {
    try {
      dispatch(fetchBlog());

      if (!contentfulClient) {
        throw new Error("Contentful client not initialized");
      }

      const data: any = await contentfulClient.getEntries({
        content_type: "homeAndAbroad",
        "fields.slug": slug,
      });

      dispatch(fetchBlogSuccess(data.items));
    } catch (err: any) {
      dispatch(fetchBlogFailure(err.message || "Unable to fetch blog"));
    }
  };
